import React, { useEffect, useState } from "react"
import PubSub from "pubsub-js"
import AldooStore from "aldoo-ra/Store"
import config from "aldoo-ra/Config"
import { configureStripeClient } from "aldoo-ra/Store/stripe-client"
import { STORE_CONFIG } from "./index"

// The publishable key of deployment.js (STRIPE_API_KEY) pairs with the API's
// secret key; the store_config one is only used when it is left at the
// template placeholder.
const isPlaceholder = (key) => !key || /your_stripe_key/i.test(key)
if (!isPlaceholder(config.STRIPE_API_KEY)) configureStripeClient({ publishableKey: config.STRIPE_API_KEY })
import { captureUTM } from "./utm"
import { releaseReservation } from "./payment"
import PlatformSelectorDialog from "./PlatformSelectorDialog"
import PurchaseRecovery from "./PurchaseRecovery"
import CartLink from "./CartLink"
import { followFunnel } from "./funnel"

/**
 * Mounted once in the layout: the aldoo-ra store (cart, checkout flow
 * "aldoo", payment success / error dialogs) plus the storefront plugins —
 * UTM capture, the "Select your license" dialog, the reservation release of
 * abandoned checkouts, the Tracking_InitiateCheckout topic, the store's own
 * funnel and kept carts (./funnel), and the purchase the server completed
 * while the buyer was away (PurchaseRecovery).
 */
export default function CheckoutHost() {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    captureUTM()
    const tokens = [
      // Abandoned checkout: free the stock held by its PaymentIntent
      PubSub.subscribe("STORE_CHECKOUT_CLOSED", (_, data) => {
        if (data?.completed) return
        releaseReservation(data?.paymentInfo)
      }),
      // Old-site topic kept for the trackers that listen to it
      PubSub.subscribe("Tracking_BeginCheckout", (_, data) => PubSub.publish("Tracking_InitiateCheckout", { ...data, price: data?.value })),
    ]
    const unfollow = followFunnel()
    return () => {
      tokens.forEach((token) => PubSub.unsubscribe(token))
      unfollow()
    }
  }, [])

  // The store reads the persisted cart (localStorage): client only
  if (!mounted) return null
  return (
    <>
      <AldooStore flow="aldoo" config={STORE_CONFIG} />
      <PlatformSelectorDialog />
      {/* a purchase finished on the server while this browser was away */}
      <PurchaseRecovery />
      {/* a link that fills the cart (?add=…), the way an email sends a buyer back */}
      <CartLink />
    </>
  )
}
